import {
  CREATEDEVICEBATCH_SUCCESS,
  UPDATEDEVICEBATCH_SUCCESS,
  FETCHDEVICEBATCHS_SUCCESS,
  DELETEDEVICEBATCH_SUCCESS,
  ONBOARDDEVICEBATCH_SUCCESS,
  FETCHDEVICEBATCH_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  deviceBatchs: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCHDEVICEBATCH_SUCCESS: {
      return {
        ...state,
        fetchedDeviceBatch: action.payload.getDeviceBatch
      }
    }

    case FETCHDEVICEBATCHS_SUCCESS: {
      return {
        ...state,
        deviceBatchs: action.payload.getDeviceBatchs
      }
    }

    case CREATEDEVICEBATCH_SUCCESS: {
      return {
        ...state,
        createdDeviceBatch: action.payload
      }
    }

    case UPDATEDEVICEBATCH_SUCCESS: {
      return {
        ...state,
        updatedDeviceBatch: action.payload
      }
    }

    case DELETEDEVICEBATCH_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case ONBOARDDEVICEBATCH_SUCCESS: {

      return {
        ...state,
        onboardedDeviceBatch: action.payload
      }
    }

    default:
      return {
        ...state,
        createdDeviceBatch: false,
        updatedDeviceBatch: false,
        deleted: false,
        fetchedDeviceBatch: false,
        onboardedDeviceBatch: false
      }
  }
}
